<template>
  <AsideMenu :tabs="tabs" />
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { ROUTE_NAMES } from '@/constants/route-names'
import AsideMenu from '@/components/AsideMenu/AsideMenu.vue'

export default {
  name: 'AccountMenu',
  components: {
    AsideMenu,
  },

  computed: {
    ...mapGetters({
      listOfReportYears: 'report/listOfReportYears',
    }),

    hasReportsRouteActive() {
      // Temporarily removed the dashboard which means the reports route is the only one left
      // return this.$route.matched.some(match => /^Account-Reports/.test(match.name))
      return true
    },

    tabs() {
      const addYearCta = {
        text: this.$t('previousYear'),
        isLight: true,
        events: {
          mouseover: () => this.preloadOverlayAddPreviousYear(),
          click: () => this.showOverlayAddPreviousYear({ onSubmit: year => this.addYear(year) }),
        },
      }
      return [
        {
          text: this.$t('taxReports'),
          to: this.localePath(ROUTE_NAMES.reports.index),
          hasChildrenVisible: () => this.hasReportsRouteActive,
          children: [
            addYearCta,
            ...this.listOfReportYears.map(year => this.getYearTabConfig(year)),
          ],
        },
        {
          text: this.$t('auth.logout'),
          events: { click: () => this.logout(this.$router) },
        },
      ]
    },
  },

  methods: {
    ...mapMutations({
      pushToVisitedReportYears: 'report/pushToVisitedReportYears',
    }),

    ...mapActions({
      preloadOverlayAddPreviousYear: 'overlay/preloadOverlayAddPreviousYear',
      showOverlayAddPreviousYear: 'overlay/showOverlayAddPreviousYear',
      logout: 'account/logout',
    }),

    getYearTabConfig(year) {
      return {
        text: year,
        to: this.localePath({ name: ROUTE_NAMES.reports.year, params: { year } }),
      }
    },

    addYear(year) {
      this.pushToVisitedReportYears(year)
      this.$router.push(this.localePath({ name: ROUTE_NAMES.reports.year, params: { year } }))
    },
  },
}
</script>

<i18n src="@/locales/account-menu.json" />
